import { useEffect, useState, createElement } from "react";
import { useSearchParams } from "react-router-dom";
import { config } from "./config";

export default function App() {
  const [searchParams] = useSearchParams();
  const [paymentRequestId, setPaymentRequestId] = useState("");

  useEffect(() => {
    const idFromQuery = searchParams.get("paymentRequestId");
    if (idFromQuery) {
      setPaymentRequestId(idFromQuery);
    }
  }, [searchParams]);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data && event.data.type) {
        if (event.data.type === "SUCCESS_PROCESSED") {
          setTimeout(() => {
            window.location.href = config.redirectUrl;
          }, 1500);
        }
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);

  return (
    <div style={{ height: "94vh", background: "#F4F4F4" }}>
      {paymentRequestId &&
        createElement("payfac-sdk", {
          paymentRequestId,
          publicKey: config.publicKey,
          settings: config.settings,
          env: config.env,
        })}
    </div>
  );
}
